export enum Region {
  'SG' = 'SG',
  'US' = 'US',
  'AU' = 'AU',
  'CA' = 'CA',
  'UK' = 'UK',
}
